import React from 'react';
import './App.css';
import MenuWrapper from './components/MenuWrapper';
import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID as string);

ReactGA.send({ hitType: "pageview", page: "/", title: "Home Page View" });
ReactGA.send({ hitType: "pageview", page: "/about", title: "About Page View" });
ReactGA.send({ hitType: "pageview", page: "/blog", title: "Blog Page View" });

const App: React.FC = () => (
  
  <div className="App">
      <MenuWrapper />
  </div>
);

export default App;
